import {Component, AfterViewChecked, OnInit} from '@angular/core';
import {ViewChild} from '@angular/core';
import {NgClass} from '@angular/common';
import {DataLayer} from './data-layer';
import {StationData} from './station-data';
import {DataLayerService} from './data-layer.service';
import {ForecastService} from './forecast.service';
import {DialogModule } from 'primeng/dialog';
import {InputTextModule} from 'primeng/inputtext';
import {TableModule} from 'primeng/table';

// declare all javascript variables/functions defined elsewhere
declare var $;

@Component({
	selector: 'impact-table-component',
	templateUrl: 'impact-table.component.html',
	styleUrls: ['impact-table.component.css']
})
export class ImpactTableComponent implements OnInit, AfterViewChecked {
	dataLayerService: DataLayerService;
	forecastService: ForecastService;
	public stationsArray: any[] = [];
	cols: any[];
	weatherInfo = {};
	dataTypeDescription: string;
	station_id: any;
	station_name: any;
	basin: any;
	numStations: string;
	novaScores: any[] = [];
	dialogVisible: boolean;
	selectedStation: any;

	sortType = 'rain';
	caret = 'fa fa-fw fa-caret-down';
	// once data types are more dynamic, sortTypeList should be dynamically created
	sortTypeList: any[] = [
		{label: 'Rain', value: 'rain'},
		{label: 'Water Level', value: 'waterLevel'},
		{label: 'Streamflow', value: 'streamflow'},
		{label: 'Wind', value: 'wind'}];

	constructor(dataLayerService: DataLayerService, forecastService: ForecastService/*, elRef:ElementRef, cdRef:ChangeDetectorRef*/) {
		this.dataLayerService = dataLayerService;
		this.forecastService = forecastService;
		// this.elRef = elRef;
		// this.cdRef = cdRef;
		this.attachEvents();
	}

	ngOnInit() {

		this.cols = [
			{ field: 'id' },
			{ field: 'name' },
			{ field: 'basin' },
			{ field: 'type' }
		];

		this.dataTypeDescription =
			'Values shown are:\n   Rain (total for interval),\n   Water Level (maximum for interval),\n   ' +
			'Streamflow (maximum for interval),\n   Wind (maximum for interval)';

		this.forecastService.readForecast()
			.subscribe ((forecast) => {
				this.forecastService.setForecast(forecast);
				const next6Hours = this.forecastService.getNext6HoursForecast();
				const nextDay = this.forecastService.getNextDayForecast();
				const nextWeek = this.forecastService.getNextWeekForecast();
				const providerURL = this.forecastService.getProviderURL();

				this.weatherInfo['next6Hours'] = next6Hours['icon'];
				this.weatherInfo['next6HoursPrecipProbability'] = next6Hours['precipProbability'];
				this.weatherInfo['next6HoursMsg'] = next6Hours['summary'];
				this.weatherInfo['nextDay'] = nextDay['icon'];
				this.weatherInfo['nextDayPrecipProbability'] = nextDay['precipProbability'];
				this.weatherInfo['nextDayMsg'] = nextDay['summary'];
				this.weatherInfo['nextWeek'] = nextWeek['icon'];
				this.weatherInfo['nextWeekPrecipProbability'] = nextWeek['precipProbability'];
				this.weatherInfo['nextWeekMsg'] = nextWeek['summary'];
				this.weatherInfo['providerURL'] = providerURL;
		});

		// set up observed data
		this.forecastService.readObservedWeatherData()
			.subscribe ({ next: observed => {
				this.forecastService.setObservedWeatherData(observed);

				const observed15Minutes = this.forecastService.getObserved15Minutes();
				this.weatherInfo['last15Minutes'] = observed15Minutes['icon'];
				this.weatherInfo['last15MinutesMsg'] = observed15Minutes['summary'];

				const observedHour = this.forecastService.getObservedHour();
				this.weatherInfo['lastHour'] = observedHour['icon'];
				this.weatherInfo['lastHourMsg'] = observedHour['summary'];

				const observed3Hours = this.forecastService.getObserved3Hours();
				this.weatherInfo['last3Hours'] = observed3Hours['icon'];
				this.weatherInfo['last3HoursMsg'] = observed3Hours['summary'];

				const observedDay = this.forecastService.getObservedDay();
				this.weatherInfo['lastDay'] = observedDay['icon'];
				this.weatherInfo['lastDayMsg'] = observedDay['summary'];

				const observedWeek = this.forecastService.getObservedWeek();
				this.weatherInfo['lastWeek'] = observedWeek['icon'];
				this.weatherInfo['lastWeekMsg'] = observedWeek['summary'];
				}
			});

		const dataLayer = this.dataLayerService.getDataLayerDetails('fitAssets');
		// console.log ( dataLayer );
		this.station_id = dataLayer.stationID;
		this.station_name = dataLayer.stationName;
		this.basin = dataLayer.special3;
		this.novaScores = dataLayer.value.novaScores;

		dataLayer.value.floodImpactSummaries.forEach(function(item) {
			let newStation: any;
			const meas_count = dataLayer.title;
			const type = dataLayer.special1;
			const capacity = dataLayer.special2;
			const upstreamStationId = dataLayer.special4;
			const lastWeek = {};
			const lastDay = {};
			const last3Hours = {};
			const lastHour = {};
			const last15Minutes = {};
			const alarmStatus = {};
			const hasData = {};

			this.retrieveStationStatistics ( item, 'PrecipAccum', 'Last', 'rain', 2,
				lastWeek, lastDay, last3Hours, lastHour, last15Minutes, alarmStatus, hasData );
			this.retrieveStationStatistics ( item, 'WaterLevelRiver', 'Max', 'waterLevel', 1,
				lastWeek, lastDay, last3Hours, lastHour, last15Minutes, alarmStatus, hasData );
			this.retrieveStationStatistics ( item, 'DischargeRiver', 'Last', 'streamflow', 1,
				lastWeek, lastDay, last3Hours, lastHour, last15Minutes, alarmStatus, hasData ); // temporary change from Max to Last
			this.retrieveStationStatistics ( item, 'WindSpeed', 'Max', 'wind', 1,
				lastWeek, lastDay, last3Hours, lastHour, last15Minutes, alarmStatus, hasData );

			newStation = { id: item[this.station_id],
					name: item[this.station_name],
					basin: item[this.basin],
					meas_count: item[meas_count],
					type: item[type],
					capacity: item[capacity],
					lastWeek: lastWeek,
					lastDay: lastDay,
					last3Hours: last3Hours,
					lastHour: lastHour,
					last15Minutes: last15Minutes,
					hasData: hasData,
					alarmStatus: alarmStatus,
					upstreamStationId: item[upstreamStationId]};

			this.stationsArray.push(newStation);
			// console.log(newStation);

		}, this);

		this.numStations = '' + this.stationsArray.length;
		console.log ( this.numStations );
	}

	ngAfterViewChecked() {
		// console.log("ngAfterViewChecked");
		// console.log($("#lastWeekColumn").width());
		const width = $('#lastWeekColumn').width();
		$('.numbers').css('width', width);
	}

	attachEvents() {
		window.onresize = () => {
			this.setStickyCSS ();
		};

	}

	sortById (order) {
		let return1 = 1;
		let return2 = -1;
		if ( order === 1 ) { // descending
			return1 = -1;
			return2 = 1;
		}
		this.stationsArray.sort(function(a, b) {
			const aId = a.id;
			const bId = b.id;
			if ( aId < bId ) { return return1; }  // return -1 for descending
			if ( aId > bId ) { return return2; }   // return 1 for descending
			// id must be same - shouldn't ever happen
			return 0;
		});
	}

	sortByName (order) {
		let return1 = 1;
		let return2 = -1;
		if ( order === 1 ) { // descending
			return1 = -1;
			return2 = 1;
		}
		this.stationsArray.sort(function(a, b) {
			const aName = a.name.toUpperCase();
			const bName = b.name.toUpperCase();
			if ( aName < bName ) { return return1; }
			if ( aName > bName ) { return return2; }
			// name must be same - shouldn't ever happen
			return 0;
		});
	}

	sortByBasin (order) {
		let return1 = 1;
		let return2 = -1;
		if ( order === 1 ) { // descending
			return1 = -1;
			return2 = 1;
		}
		this.stationsArray.sort(function(a, b) {
			const aName = a.basin.toUpperCase();
			const bName = b.basin.toUpperCase();
			if ( aName < bName ) { return return1; }
			if ( aName > bName ) { return return2; }
			// name must be same
			return 0;
		});
	}

	sortByThreat () {
		// descending
		const return1 = 1;
		const return2 = -1;

		this.stationsArray.sort(function(a, b) {
			console.log(a);
			let aValue = a.alarmStatus.streamflowNovaScore;
			let bValue = b.alarmStatus.streamflowNovaScore;
			aValue = (aValue === '-') ? -999 : Number(aValue);
			bValue = (bValue === '-') ? -999 : Number(bValue);
			if ( aValue < bValue ) { return return1; }
			if ( aValue > bValue ) { return return2; }
			// they are the same
			return 0;
		});
	}

	newSortDataTypeSelected (sortType) {
		this.sortType = sortType;
		console.log(sortType);
	}

	sortByDataTypeHelper(interval, order) {
		this.sortByDataType(this.sortType, interval, order);
	}

	// dataType is the display data type:  "rain", "waterLevel", "streamflow", "wind"
	sortByDataType (dataType, interval, order) {
		$('#topHeader').css('cursor', 'wait' );
		let return1 = 1;
		let return2 = -1;
		if ( order === 1 ) { // descending
			return1 = -1;
			return2 = 1;
		}

		this.stationsArray.sort(function(a, b) {
			console.log(a);
			let aValue = a[interval][dataType];
			let bValue = b[interval][dataType];
			aValue = (aValue === '-') ? -999 : Number(aValue);
			bValue = (bValue === '-') ? -999 : Number(bValue);
			if ( aValue < bValue ) { return return1; }
			if ( aValue > bValue ) { return return2; }
			// they are the same
			return 0;
		});

		$('#topHeader').css('cursor', 'default' );
	}

	/* Retrieve the time series data from our datafile.  This fills in data for each time interval for a particular dataType.
	** stationInfo is a single station json object
	** dataType refers to the dataType in the datafile
	** displayType refers to the datatype in the html
	** 		At some point, these could be made the same.  The value in making them different is if dataTypes in the data file change,
	**			the html doesn't need to change.
	** 		currently the dataType/displayType combinations are:
	**			? - "weather"
	**			"PrecipAccum" - "rain"
	**			"WaterLevelRiver" - "waterLevel"
	**			"DischargeRiver" - "streamflow"  // no streamflow at this point?
	**			"WindSpeed" - "wind"
	**
	** lastWeek, lastDay, last3Hours, lastHour, last15Minutes are json objects in which to save time series information for dataType
	*/
	retrieveStationStatistics ( stationInfo, dataType, statisticType, displayType, precision,
		lastWeek, lastDay, last3Hours, lastHour, last15Minutes, alarmStatus, hasData ) {
		// set default values
		let lastWeekValue = '-';
		let lastDayValue = '-';
		let last3HoursValue = '-';
		let lastHourValue = '-';
		let last15MinutesValue = '-';
		let alarmStatusValue = '-';
		const alarmClasses = { };

		const lastWeekStatistic = this.retrieveStatistics ( stationInfo, dataType, statisticType, '7day' );

		if ( lastWeekStatistic != null && lastWeekStatistic.statisticValue != null ) {
			lastWeekValue = lastWeekStatistic.statisticValue.toFixed(precision);
		}
		const lastDayStatistic = this.retrieveStatistics ( stationInfo, dataType, statisticType, '1day' );
		if ( lastDayStatistic != null && lastDayStatistic.statisticValue != null) {
			lastDayValue = lastDayStatistic.statisticValue.toFixed(precision);
		}
		const last3HoursStatistic = this.retrieveStatistics ( stationInfo, dataType, statisticType, '3hour' );
		if ( last3HoursStatistic != null && last3HoursStatistic.statisticValue != null ) {
			last3HoursValue = last3HoursStatistic.statisticValue.toFixed(precision);
		}
		const lastHourStatistic = this.retrieveStatistics ( stationInfo, dataType, statisticType, '1hour' );
		if ( lastHourStatistic != null && lastHourStatistic.statisticValue != null ) {
			lastHourValue = lastHourStatistic.statisticValue.toFixed(precision);
		}
		const last15MinutesStatistic = this.retrieveStatistics ( stationInfo, dataType, statisticType, '15minute' );
		if ( last15MinutesStatistic != null && last15MinutesStatistic.statisticValue != null ) {
			last15MinutesValue = last15MinutesStatistic.statisticValue.toFixed(precision);
			alarmStatusValue = last15MinutesStatistic.novaScore;
			// set the class for alarm status
			if ( +alarmStatusValue === 16 ) { alarmClasses['warning'] = true; } else if ( +alarmStatusValue >= 17 ) { alarmClasses['alarm'] = true; }
		}

		// fill in values for dataType if any values were found
		// if ( lastWeekValue != "-" || lastDayValue != "-" || last3HoursValue != "-" || lastHourValue != "-" || lsat15MinutesValue != "-" ) {
		lastWeek[displayType] = lastWeekValue;
		lastDay[displayType] = lastDayValue;
		last3Hours[displayType] = last3HoursValue;
		lastHour[displayType] = lastHourValue;
		last15Minutes[displayType] = last15MinutesValue;

		hasData[displayType] = (lastWeekValue === '-' && lastDayValue === '-' && last3HoursValue === '-' &&
			lastHourValue === '-' && last15MinutesValue === '-') ? false : true;

		alarmStatus[displayType + 'NovaScore'] = alarmStatusValue;
		alarmStatus[displayType] = this.translateToNovaScoreName(alarmStatusValue);
		// console.log(alarmClasses);
		alarmStatus[displayType + 'class'] = alarmClasses;
		// console.log(alarmStatus);
	}
	// helper function to retrieveStationStatistics
	retrieveStatistics ( stationInfo, dataType, statisticType, duration ) {
		const statisticArray = stationInfo.statistics;
		const statistics = statisticArray.filter( s => {
			return s.dataType === dataType &&
			s.statisticType === statisticType &&
			s.duration.toUpperCase() === duration.toUpperCase(); });

		// console.log(statistics);
		if ( statistics == null || statistics.length === 0 ) {
			return null;
		} else { return statistics[0]; }
	}

	// helper function to retrieve retrieveStationStatistics
	// translates a numerical novaScore to the name
	translateToNovaScoreName ( novaScore: any ): string {
		// console.log(novaScore);
		if ( novaScore === '-' || novaScore === 0 ) { return novaScore; }

		const novaScoreName = this.novaScores.filter ( ns => {
			return ns.id === novaScore;
		});
		const name = novaScoreName[0].shortDisplayName;
		return name;
	}

	setStickyCSS () {
		const topHeaderHeight = $('#topHeader').height();
		$('#tableBody').css('padding-top', topHeaderHeight );
	}

	// showUpstreamStations(station: any) {
	showUpstreamStations() {
		// showUpstreamStations() {
		// this.selectedStation = station;
		// this.dialogVisible = true;
		console.log('hello');
	}

	showDialog() {
		this.dialogVisible = true;
	}
}
